<template>
	<div class="pr-1">

		<div class="pb-2" v-if="dataUsed.results.length == 0">
			<not-found></not-found>
		</div>
		<div v-else class="mt-n2">
			<apexchart type="line" height="310" :options="chartOptions" :series="series"></apexchart>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart,
	},
	data() {
		return {
		}
	},
	props: {
		fitur: {
			type: String
		}
	},
	computed: {
		...mapState('dashboardAll', ['listSalesPriceWeekly', 'listSalesRetailPriceWeekly']),

		chartOptions() {
			return {
				chart: {
					type: 'line',
					zoom: {
						enabled: false
					},
					toolbar: {
						show: false,
					}
				},
				colors: ['#512DA8'],
				dataLabels: {
					enabled: true,
					formatter: (val) => {
						return this.$options.filters.toRupiah(val)
					}
				},
				stroke: {
					curve: 'smooth'
				},
				grid: {
					row: 
					{
						colors: ['#f3f3f3', 'transparent'],
						opacity: 0.5
					},
				},
				xaxis: {
					categories: this.dataUsed.day_arr,
				},
				yaxis: {
					labels: {
						formatter: (val) => {
							return this.$options.filters.toRupiah(val)
						}
					},
				},
			}
		},
		series() {
			return [{
				name: "Total Pemasukan",
				data: this.dataUsed.results
			}]
		},
		dataUsed() {
			if (this.fitur == 'sales-retail')
				return this.listSalesRetailPriceWeekly
			else
				return this.listSalesPriceWeekly
		}
	},
	methods: {
		...mapActions('dashboardAll', ['getSalesPriceWeekly', 'getSalesRetailPriceWeekly']),
	},
	created() {
		if (this.fitur == 'sales-retail')
			this.getSalesRetailPriceWeekly()
		else
			this.getSalesPriceWeekly()
	}
}
</script>